module.exports = __webpack_public_path__ + "static/img/lv1.0cbd0285.png";